export const _langs = {es: 'Es'}

export const paths = {}

export const config = {
  ckeditorUrl: '/static/ckeditor/',
  lang: {
    default: 'es',
    ide: 'currentLang'
  },
  jwt: 'palermo_jwt',
  api: {
    url: 'https://api.abastecedorapalermo.com/api/v4'
  },
  statics: {
    url: 'https://api.abastecedorapalermo.com/static/',
    dummy: '/static/images/dummy.png'
  }
}

export const GMaps = {
  key: 'xxxxxxxxxxxxx'
}



// WEBPACK FOOTER //
// ./src/core/config/base.js